import apiMiddleware from "../../../api/apiMiddleware";

// list
// export const list = async (page = 1) => {
//   try {
//     const response = await apiMiddleware.get(`/package-groups?page=${page}`);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

// Fetch subpackages for a given groupId
export const listAllPackages = async (page = 1, filters = {}, perPage = 10) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("per_page", perPage);

  if (filters.search) {
    params.append("search", filters.search);
  }
  if (filters.tour_type && filters.tour_type !== "all") {
    params.append("tour_type", filters.tour_type);
  }
  if (filters.status && filters.status !== "all") {
    params.append("status", filters.status);
  }
  if (filters.approval_status && filters.approval_status !== "all") {
    params.append("is_approved", filters.approval_status);
  }
  if (filters.supplier_id && filters.supplier_id !== "all") {
    params.append("supplier_id", filters.supplier_id);
  }

  const response = await apiMiddleware.get(
    `/packages-admin?${params.toString()}`
  );
  return response.data;
};

// GENERAL INFO  ==========
// Fetch suitable for options
export const fetchSuitableFor = async () => {
  const response = await apiMiddleware.get("/list-suitable-masters");
  return response.data;
};

// Fetch activities
export const fetchActivities = async () => {
  const response = await apiMiddleware.get("/list-activity-masters");
  return response.data;
};

export const createActivityMaster = async ({ name }) => {
  const response = await apiMiddleware.post("/activity-master", {
    name,
    status: 1,
  });
  return response.data;
};

// Fetch package details
export const fetchPackageDetails = async (packageId) => {
  const response = await apiMiddleware.get(`/packages/${packageId}`);
  return response.data;
};

export const packageSettings = async (packageId, data) => {
  const payload = {
    is_approved: Number(data.is_approved),
    popular: Number(data.popular) === 1 ? 1 : 0,
    recommended: Number(data.recommended) === 1 ? 1 : 0,
    status: Number(data.status) === 1 ? 1 : 0,
  };

  const response = await apiMiddleware.post(
    `/package-settings/${packageId}?_method=PUT`,
    payload
  );
  return response.data;
};

// Create new package
export const createGeneralInfo = async (packageData) => {
  const response = await apiMiddleware.post(
    "/package-general-info",
    packageData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// Get general info
export const getGeneralInfo = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-general-info/${packageId}`
  );
  return response.data;
};

// Update package
export const updateGeneralInfo = async (packageId, packageData) => {
  const response = await apiMiddleware.post(
    `/package-general-info/${packageId}?_method=PUT`,
    packageData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// Save package as draft
export const saveGeneralInfoAsDraft = async (packageData) => {
  const response = await apiMiddleware.post(
    "/package-general-info/draft",
    packageData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// Delete general info images
export const deleteGeneralInfoImages = async (imageId) => {
  const response = await apiMiddleware.delete(`/package-image/${imageId}`);
  return response.data;
};

// delete days in each destination
export const deleteDaysInEachDestination = async (itemId) => {
  const response = await apiMiddleware.delete(
    `/package-days-each-destination/${itemId}`
  );
  return response.data;
};

// ITINEAR SERVICES ==========
// basic itinerary
export const fetchBasicItinerary = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-itinerary?package_id=${packageId}`
  );
  return response.data;
};

// Itineary Food Master
export const fetchItineraryFoodMaster = async () => {
  const response = await apiMiddleware.get("/get-food-masters");
  return response.data;
};

// Itineary Attraction Master
export const fetchItineraryAttractionMaster = async () => {
  const response = await apiMiddleware.get("/get-attraction-masters");
  return response.data;
};

export const deleteItineraryAttractionMaster = async (id) => {
  const response = await apiMiddleware.delete(`/itinerary-attraction-master/${id}`);
  return response.data;
};

// update itinerary
export const buildItineraryUpdateFormData = (data) => {
  const formData = new FormData();
  Object.entries(data || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value);
    } else {
      formData.append(key, value);
    }
  });
  return formData;
};

export const updateItinerary = async (packageId, itineraryData) => {
  const formData = buildItineraryUpdateFormData(itineraryData);
  const response = await apiMiddleware.post(
    `/package-itinerary/${packageId}?_method=PUT`,
    formData
  );
  return response.data;
};

export const reorderItinerary = async ({ package_id, order }) => {
  const response = await apiMiddleware.post(`/package-itinerary-reorder`, {
    package_id,
    order,
  });
  return response.data;
};

export const deleteItineraryDay = async (itineraryDayId) => {
  const response = await apiMiddleware.delete(`/package-itinerary/${itineraryDayId}`);
  return response.data;
};

//  get itinearay by id
export const getItinerary = async (packageId) => {
  const response = await apiMiddleware.get(`/package-itinerary/${packageId}`);
  return response.data;
};

// update stage status for itinerary
export const updateItineraryStageStatus = async ({
  package_id,
  current_stage,
  is_draft,
}) => {
  const response = await apiMiddleware.post(`/package-itinerary-continue`, {
    package_id,
    current_stage,
    is_draft,
  });
  return response.data;
};

// STAY SERVICES ==========

// get stay by id
export const stayMaster = async () => {
  const response = await apiMiddleware.get("/list-stay-masters");
  return response.data;
};

// hotel masters
export const hotelMaster = async (destination, packageId) => {
  const response = await apiMiddleware.get(
    `/list-supplier-hotel-masters/${destination}`,
    {
      params: {
        package_id: packageId,
      },
    }
  );
  return response.data;
};

// existing hotel masters
export const hotelDestinationMaster = async (packageId) => {
  const response = await apiMiddleware.get(`/old-hotel-destinations`, {
    params: {
      package_id: packageId,
    },
  });
  return response.data;
};

// get stay data
export const stayData = async (packageId) => {
  const response = await apiMiddleware.get(`/package-stay/${packageId}`);
  return response.data;
};

// add stay data
export const addPackageStay = async (data) => {
  const response = await apiMiddleware.post("/package-stay", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// add stay data
export const packageStaySaveContinue = async (data) => {
  const response = await apiMiddleware.post("/package-stay-continue", data);
  return response.data;
};

// update stay data
export const updatePackageStay = async (data, stayId) => {
  const response = await apiMiddleware.post(
    `/package-stay/${stayId}?_method=PUT`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// delete stay data
export const deletePackageStay = async (stayId) => {
  const response = await apiMiddleware.delete(`/package-stay/${stayId}`);
  return response.data;
};

// delete hotel from stay
export const deleteHotelFromStay = async (hotelId) => {
  const response = await apiMiddleware.delete(`/package-stay-hotel/${hotelId}`);
  return response.data;
};

// INCLUSION SERVICES ==========

// get inclusion master
export const inclusionMaster = async () => {
  const response = await apiMiddleware.get(`/inclusion-master-list`);
  return response.data;
};

// inclusion data
export const inclusionData = async (packageId) => {
  const response = await apiMiddleware.get(`/package-inclusion/${packageId}`);
  return response.data;
};

// save inclusion data
export const saveInclusionData = async (data) => {
  const response = await apiMiddleware.post(`/package-inclusion`, data);
  return response.data;
};

// update inclusion data
export const updateInclusionData = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-inclusion/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// PRICING SERVICES ==========

// package price stop sales
export const addPackagePriceStopSales = async (data) => {
  console.log("data", data);
  const response = await apiMiddleware.post(`/package-price-stop-sale`, data);
  return response.data;
};

export const listPackagePriceStopSales = async (
  packageId,
  packageStayCategoryId
) => {
  const response = await apiMiddleware.get(
    `/package-price-stop-sale?package_id=${packageId}&package_stay_category_id=${packageStayCategoryId}`
  );
  return response.data;
};

// get pricing data
export const pricingMaster = async (packageId) => {
  const response = await apiMiddleware.get(`/package-stay-category-masters`, {
    params: {
      package_id: packageId,
    },
  });
  return response.data;
};

// add rates
export const addRates = async (data) => {
  const response = await apiMiddleware.post("/package-price-rates", data);
  return response.data;
};

// get recently added rates based on package id and stay category id and package stay category id
export const getRecentlyAddedRates = async (
  type,
  packageId,
  stayCategoryId,
  packageStayCategoryId
) => {
  // Validate rate type
  const validTypes = ["normal", "seasonal", "stop"];
  if (!validTypes.includes(type)) {
    throw new Error(`Invalid rate type: ${type}`);
  }

  const response = await apiMiddleware.get(`/package-price-${type}`, {
    params: {
      package_id: packageId,
      stay_category_id: stayCategoryId,
      package_stay_category_id: packageStayCategoryId,
    },
  });
  return response.data;
};

// get Pricing data
export const getExistingPricingData = async (
  packageId,
  packageStayCategoryId
) => {
  const response = await apiMiddleware.get(
    `/package-price-rates?package_id=${packageId}&package_stay_category_id=${packageStayCategoryId}`
  );
  return response.data;
};

// get base price
export const getBasePrice = async (data) => {
  const response = await apiMiddleware.get(`/package-price-base-rates`, {
    params: data,
  });
  return response.data;
};
// insert base price
export const insertBasePrice = async (data) => {
  const response = await apiMiddleware.post(`/package-price-base-rates`, data);
  return response.data;
};
// update base price
export const updateBasePrice = async (data, id) => {
  const response = await apiMiddleware.post(
    `/package-price-base-rates/${id}?_method=PUT`,
    data
  );
  return response.data;
};

// save and continue pricing
export const saveAndContinuePricing = async (data) => {
  const response = await apiMiddleware.post(
    `/package-price-save-and-continue`,
    data
  );
  return response.data;
};

// save and continue pricing
export const getDiscountAndPaymentData = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-price-discount-and-payment-type?package_id=${packageId}`
  );
  return response.data;
};

// DEMO SERVICES - Replace with actual endpoints later
// delete rate
export const deleteRate = async (rateId) => {
  // Demo implementation - replace with actual API call
  console.log("Demo: Deleting rate with ID:", rateId);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Rate deleted successfully" });
    }, 1000);
  });
};

// update rate
export const updateRate = async (rateId, data) => {
  // Demo implementation - replace with actual API call
  console.log("Demo: Updating rate with ID:", rateId, "Data:", data);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Rate updated successfully", data });
    }, 1000);
  });
};

// delete stop sale
export const deleteStopSale = async (stopSaleId) => {
  // Demo implementation - replace with actual API call
  console.log("Demo: Deleting stop sale with ID:", stopSaleId);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Stop sale deleted successfully" });
    }, 1000);
  });
};

// update stop sale
export const updateStopSale = async (stopSaleId, data) => {
  // Demo implementation - replace with actual API call
  console.log("Demo: Updating stop sale with ID:", stopSaleId, "Data:", data);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: "Stop sale updated successfully",
        data,
      });
    }, 1000);
  });
};

// ADDITIONAL INFO SERVICES ==========

// add additional info
export const additionalInfoData = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-additional-info/${packageId}`
  );
  return response.data;
};

// update additional info
export const updateAdditionalInfo = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-additional-info/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// TERMS AND CONDITIONS SERVICES ==========

// get terms and conditions
export const getTermsAndConditions = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-terms-and-conditions/${packageId}`
  );
  return response.data;
};

// update terms and conditions
export const updateTermsAndConditions = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-terms-and-conditions/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// FAQ SERVICES ==========

// get faq
export const getFaq = async (packageId) => {
  const response = await apiMiddleware.get(`/package-faq/${packageId}`);
  return response.data;
};

// update faq
export const updateFaq = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-faq/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// add faq
export const addFaq = async (packageId, data) => {
  console.log("data", data);
  const response = await apiMiddleware.post(`/package-faq`, data);
  return response.data;
};

// delete faq
export const deleteFaq = async (packageId) => {
  const response = await apiMiddleware.delete(`/package-faq/${packageId}`);
  return response.data;
};

// cancellation services ==========

// store cancellation policy
export const createCancellationPolicy = async (data) => {
  const response = await apiMiddleware.post(
    `/package-cancellation-policy`,
    data
  );
  return response.data;
};

// get cancellation policy
export const getCancellationPolicy = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-cancellation-policy/${packageId}`
  );
  return response.data;
};

// update cancellation policy
export const updateCancellationPolicy = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-cancellation-policy/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// delete cancellation policy
export const deleteCancellationPolicy = async (packageId) => {
  const response = await apiMiddleware.post(
    `/package-cancellation-policy/${packageId}?_method=DELETE`
  );
  return response.data;
};

export const downloadPackageItineraryAdmin = async ({
  packageId,
  packageName,
  stayCategoryId,
  daywise,
  startDate,
  customPrefixDays = [],
}) => {
  const baseUrl = (process.env.REACT_APP_API_URL || "http://127.0.0.1:8000") + "/api";
  const token =
    localStorage.getItem("admin_token") || localStorage.getItem("token");

  const response = await fetch(
    `${baseUrl}/admin/package-download-itinerary/${packageId}`,
    {
      method: "POST",
      headers: {
        Accept: "application/pdf",
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        stay_category_id: Number(stayCategoryId),
        daywise: Boolean(daywise),
        start_date: !daywise && startDate ? startDate : null,
        custom_prefix_days: customPrefixDays.map((day) => ({
          title: day.title || "",
          description: day.description || "",
        })),
      }),
    }
  );

  if (!response.ok) {
    let message = "Failed to download itinerary";
    try {
      const payload = await response.json();
      message = payload?.message || message;
    } catch {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = `${packageName || "package"}-itinerary.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};
